import SectionProvider from '@builder/sections/SectionProvider'

export const name = 'Blog Author Box'
export const group = 'Dynamic Post Template'
export const beta = false

export const defaultOptions = {
  content: {
    data: {
      type: 'author-box-mod'
    }
  }
}

export const icon = `
`

export default class ElPostCategories extends SectionProvider {
  constructor (options = {}) {
    super('ElBlogAuthorBox', options)

    this.name = name
    this.group = group
    this.defaultOptions = defaultOptions
  }
}
